import React from 'react';
import { Box } from '@mui/material';
import { IngestionJobLog } from '../../services/integrationApi';
import { groupHeading, ingest } from './ingestionTokens';
import { formatLogLine, logLineColor } from './runFacts';

interface RunLogPanelProps {
  logs: IngestionJobLog[];
  /** Email or 'schedule' — who started the run this log belongs to. */
  actor?: string;
  maxHeight?: number;
  padding?: string;
  children?: React.ReactNode;
}

/** The expanded log panel shared by Runs & logs and the Ingestion jobs table. */
export const RunLogPanel: React.FC<RunLogPanelProps> = ({
  logs,
  actor,
  maxHeight = 200,
  padding = '12px 14px 14px',
  children,
}) => (
  <Box sx={{ padding, background: ingest.color.sunken, borderBottom: `1px solid ${ingest.color.borderInner}` }}>
    <Box sx={{ ...groupHeading, fontSize: '11px', letterSpacing: '0.07em', color: ingest.color.faintAlt, mb: '7px' }}>
      Recent logs
    </Box>
    <Box
      sx={{
        border: `1px solid ${ingest.color.borderInner}`,
        borderRadius: '7px',
        background: ingest.color.surface,
        padding: '11px 13px',
        maxHeight,
        overflowY: 'auto',
        overflowX: 'auto',
      }}
    >
      {logs.length === 0 ? (
        <Box sx={{ fontFamily: ingest.font.mono, fontSize: '11.5px', color: ingest.color.faintAlt }}>
          No logs recorded for this run.
        </Box>
      ) : (
        logs.map((log, index) => (
          <Box
            key={`${log.timestamp}-${index}`}
            sx={{
              fontFamily: ingest.font.mono,
              fontSize: '11.5px',
              lineHeight: 1.75,
              whiteSpace: 'pre',
              color: logLineColor(log),
            }}
          >
            {formatLogLine(log)}
          </Box>
        ))
      )}
    </Box>
    {children}
    {actor && (
      <Box sx={{ fontFamily: ingest.font.sans, fontSize: '11.5px', color: ingest.color.faintAlt, mt: '7px' }}>
        Triggered by {actor}
      </Box>
    )}
  </Box>
);

export default RunLogPanel;
